import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/timeoff/lib/Calendar_teamsCollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
